// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".not-found-page{margin-top:12px}.not-found-page .not-found-content{margin-left:10px}\n", "",{"version":3,"sources":["webpack://./src/styles/not-found-page.scss"],"names":[],"mappings":"AAAA,gBACE,eAAgB,CADlB,mCAII,gBAAiB","sourcesContent":[".not-found-page {\n  margin-top: 12px;\n\n  .not-found-content {\n    margin-left: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
